import React, { useState, useEffect } from 'react'
import axios from "axios"
import parse from 'html-react-parser'
import { useParams, Link, useNavigate } from "react-router-dom"

const View = () => {
    const navigate = useNavigate()

    const { key, judul } = useParams()
    const [list, setList] = useState([])
    const [title, setTitle] = useState('')
    const [profile, setProfile] = useState('')
    const [description, setDescription] = useState('')
    const [urls, setUrls] = useState([])
    const [mainImg, setMainImg] = useState('')

    // KUNCI UTAMA: Setiap 'code' di URL berubah, block ini bakal jalan otomatis bray!
    useEffect(() => {
        getData()
        getList()
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [key]) // <--- Masukin 'code' ke sini biar auto-reload pas ganti data

    const getData = async (targetCode) => {
        try {
            // Pas pertama kali load, dia bakal nangkep variabel 'key' dari URL breadcrumb lu
            const currentCode = targetCode || key

            if (!currentCode) return

            const response = await axios.post("/api/promotion/publish", {
                code: currentCode, // Tetap dikirim sebagai 'code' ke backend bray!
                jml: 1
            })

            if (response.data && response.data.length > 0) {
                const item = response.data[0]
                setProfile(item.profile)
                setTitle(item.title)
                setDescription(item.description)

                const allFiles = [item.filePath, item.filePath2, item.filePath3, item.filePath4, item.filePath5].filter(u => u)
                setUrls(allFiles)
                setMainImg(allFiles[0])
            } else {
                console.warn("Data promosi tidak ditemukan di DB.")
            }
        } catch (error) {
            console.error("Gagal load detail promosi:", error)
        }
    }

    const getList = async () => {
        try {
            const response = await axios.post("/api/promotion/publish", {
                jml: 5
            })
            setList(response.data)
        } catch (error) {
            console.error("Gagal load sidebar list:", error)
        }
    }

    const handleSelectPromosi = (val) => {
        const slugTitle = val.title.replaceAll(' ', '-').replaceAll('/', '_').toLowerCase()
        // Pindahkan URL browser ke promosi yang diklik
        navigate(`/promosi/${val.code}/${slugTitle}`)
    }

    return (<>
        <header className="ms-hero-page-override-home no-mt pb-4">
            <div className="container">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb breadcrumb-slash">
                        <li className="breadcrumb-item">
                            <Link to={'/'} className="btn btn-raised btn-primary br-2 no-m">BERANDA</Link>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">PRODUK UMKM</li>
                        <li className="breadcrumb-item active">
                            {judul ? judul.replaceAll('-', ' ').replaceAll('_', '/').toUpperCase() : ''}
                        </li>
                    </ol>
                </nav>
                <div className="row mt-4">
                    <div className="col-md-3">
                        <div className="card card-primary">
                            <div className="card-header">
                                <h3 className='panel-judul'>PROMOSI LAINNYA</h3>
                            </div>
                            <div className="card-body">
                                <div className="ms-media-list">
                                    {list && list.length > 0 ? list
                                        // 1. Saring dulu: Hanya loloskan data yang kodenya TIDAK SAMA dengan key/code aktif di URL bray
                                        .filter(val => val.code !== key)
                                        // 2. Baru setelah bersih dari data utama, kita mapping ke HTML
                                        .map((val, index) => (
                                            <div
                                                onClick={() => handleSelectPromosi(val)}
                                                key={index}
                                                className="media mb-2 d-block border-bottom pb-2 text-decoration-none"
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <div className="media-body">
                                                    <span className="media-heading color-dark font-bold d-block text-truncate" title={val.title}>
                                                        {val.title}
                                                    </span>
                                                    <div className="media-footer text-small color-dark">
                                                        <span className="mr-1 text-truncate d-block">
                                                            {val.description ? val.description.replace(/<[^>]*>/g, '').substring(0, 45) + '...' : ''}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        )) : <p className="text-center text-muted p-2">Tidak ada promosi lain</p>}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-7">
                        <h1 className='color-dark font-bold lh-125'>{title}</h1>
                        <h3 className='font-bold text-dark mb-3'>{profile}</h3>

                        <div className="content-detail color-dark lead">
                            {description ? parse(description) : ''}
                        </div>

                        <div className="row mt-2">

                            {/* Gambar Utama */}
                            <div className="col-md-10 mb-3">
                                <img
                                    src={mainImg}
                                    className="img-fluid shadow-sm"
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                        borderRadius: '5px'
                                    }}
                                    alt="Main"
                                />
                            </div>

                            {/* Thumbnail di samping */}
                            <div className="col-md-2">
                                {urls.length > 1 && urls.map((img, i) => (
                                    <div key={i} className="mb-2">
                                        <img
                                            src={img}
                                            className={`img-fluid shadow-sm ${mainImg === img ? 'border border-primary' : ''
                                                }`}
                                            style={{
                                                width: '100%',
                                                height: '60px',
                                                objectFit: 'cover',
                                                cursor: 'pointer',
                                                borderRadius: '3px',
                                                opacity: mainImg === img ? '1' : '0.7'
                                            }}
                                            onClick={() => setMainImg(img)}
                                            alt={`Thumb ${i}`}
                                        />
                                    </div>
                                ))}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </header>
    </>)
}

export default View